import { render } from "./PlanList.vue?vue&type=template&id=5b54535a&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"

import "./PlanList.vue?vue&type=style&index=0&id=5b54535a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b54535a"]])

export default __exports__